'use client';
import { useEffect } from 'react';

/**
 * [ROY] For now, I am placing this hook here in order to keep it close to the
 * with the video carousel because it is doing something a little more complex
 * than other modals in order to disable scroll on iOS.
 * This doesn't support other modals or be used in multi-modal situations yet
 * but it could be a starting point for that.
 */
const useDisableScroll = (shouldDisable) => {
  useEffect(() => {
    if (shouldDisable) {
      disableScroll();
    } else {
      enableScroll();
    }

    return () => {
      enableScroll();
    };
  }, [shouldDisable]);
};

const preventDefault = (e) => {
  if (e.cancelable) e.preventDefault();
};

const disableScroll = () => {
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  // Use CSS custom property to avoid direct style manipulation causing CLS
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${scrollbarWidth}px`
  );
  document.body.classList.add('modal-open');
  document.body.addEventListener('touchmove', preventDefault, {
    passive: false // Defaults to true on iOS
  });
};

const enableScroll = () => {
  document.documentElement.style.removeProperty('--scrollbar-width');
  document.body.classList.remove('modal-open');
  document.body.removeEventListener('touchmove', preventDefault, {
    passive: false
  });
};

export default useDisableScroll;
